<template>
  <b-button
    class="save-button"
    :type="type"
    :disabled="(loading || disabled)"
  >
    <div class="d-flex align-items-center">
      <span>{{ btnLabel }}</span>
      <b-spinner
        v-if="loading"
        small
        class="ml-1"
      />
    </div>
  </b-button>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BSpinner,
  },
  props: {
    btnLabel: { type: String, default: 'Save' },
    type: { type: String, default: 'button' },
    loading: { type: Boolean, default: false },
    disabled : { type: Boolean , default: false}
  },
}
</script>

<style scoped>
.save-button,
.save-button:focus {
  background-color: #37be69 !important;
  border-color: #37be69 !important;
  color: white !important;
}

.save-button {
  padding: 15px 24px;
}

.save-button:hover:not(.disabled):not(:disabled) {
  box-shadow: 0 8px 25px -8px #37be69 !important;
}
</style>
